import {Tenant} from './tenant';
import {Organization} from './organization';
import {KpiMeasurement} from './kpi-measurement';
import {MeasurementType} from "./measurement-type";

export class Kpi {
  uuid: string;
  name: string;
  description: string;
  tenant: Tenant;
  organization: Organization;
  timePeriod: string;
  operation: string;
  measurements: KpiMeasurement[];
  timezone: string;
  calculateIfMissingData: boolean;
  measurementType: MeasurementType;
  dateLastValueReported: number;
  lastValueReported: string;
}
